export const alluser = [
  {
    id: 1,
    name: "Irwin Winborn",
    img: "https://i.pravatar.cc/150?u=13121",
    email: "iwinborn0@ask.com",
    auth: { isAdmin: false, isVerified: false },
  },
  {
    id: 2,
    name: "Casandra Fowlston",
    img: "https://i.pravatar.cc/150?u=13121",
    email: "cfowlston1@vinaora.com",
    auth: { isAdmin: false, isVerified: false },
  },
  {
    id: 3,
    name: "Dale Perot",
    img: "https://i.pravatar.cc/150?u=13122",
    email: "dperot2@army.mil",
    auth: { isAdmin: false, isVerified: false },
  },
  {
    id: 4,
    name: "Jemima Dobbin",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "jdobbin3@opera.com",
    auth: { isAdmin: false, isVerified: false },
  },
  {
    id: 5,
    name: "Tedda Tease",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "ttease4@java.com",
    auth: { isAdmin: false, isVerified: true },
  },
  {
    id: 6,
    name: "Farlie Doy",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "fdoy5@wunderground.com",
    auth: { isAdmin: false, isVerified: false },
  },
  {
    id: 7,
    name: "Jay Gammell",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "jgammell6@epa.gov",
    auth: { isAdmin: false, isVerified: false },
  },
  {
    id: 8,
    name: "Janina Rush",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "jrush7@last.fm",
    auth: { isAdmin: false, isVerified: true },
  },
  {
    id: 9,
    name: "Ellynn Dark",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "edark8@columbia.edu",
    auth: { isAdmin: false, isVerified: false },
  },
  {
    id: 10,
    name: "Dorella Rizzotto",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "drizzotto9@stumbleupon.com",
    auth: { isAdmin: false, isVerified: false },
  },
  {
    id: 11,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 12,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 13,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 14,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 15,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 16,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 17,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 18,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 19,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 20,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 21,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 22,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
  {
    id: 23,
    name: "Randone Vai",
    img: "https://i.pravatar.cc/150?u=1312",
    email: "iftakhar.radone@gmail.com",
    auth: { isAdmin: true, isVerified: false },
  },
];
